import { PageSection } from '../../components/ui'
import { AccessDeniedView } from './components'
import '../../styles/pages/page-common.css'
import '../../styles/pages/autotests.css'

export default function AutotestsAccessDeniedPage() {
  return (
    <PageSection className="autotests-page" title="Autotests">
      <AccessDeniedView />
    </PageSection>
  )
}
